// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"66b0c185","135":"8a727283","494":"31a9895d","816":"cdae38ba"}[chunkId] + ".js";
};